// extracted by mini-css-extract-plugin
module.exports = {"container":"BulkPurchaseModal_container__2vHYU","title":"BulkPurchaseModal_title__2Wmib","body":"BulkPurchaseModal_body__1AV76","highlight":"BulkPurchaseModal_highlight__1d-gO"};